module.exports = __webpack_public_path__ + "img/electronic_electric_reserved_selected.9873d6c8.svg";